<template>
    <div class="checkout">
        <a
            :href="messages.editOrder.LINK"
            class="checkout-edit"
        >
            <svg><use xlink:href="#svg-arrow-left-blue"></use></svg>
            {{ messages.editOrder.TITLE }}
        </a>
        <DefTitle :result="3">
            <h2>{{ messages.orderTitle }}</h2>
        </DefTitle>
        <form
            class="checkout-grid"
            @submit.prevent="saveOrder"
        >
            <div class="checkout-steps">
                <CheckoutBlock>
                    <template #header>
                        <DefTitle :result="5">{{ contactTitle }}</DefTitle>
                    </template>
                    <CheckoutContact />
                </CheckoutBlock>
                <CheckoutBlock>
                    <template #header>
                        <DefTitle :result="5">{{ deliveryTitle }}</DefTitle>
                    </template>
                    <CheckoutDelivery />
                </CheckoutBlock>
                <CheckoutBlock>
                    <template #header>
                        <DefTitle :result="5">{{ paySystemTitle }}</DefTitle>
                    </template>
                    <CheckoutPaySystem />
                    <Certificate class="width-limiter" />
                </CheckoutBlock>
                <CheckoutBlock>
                    <template #header>
                        <DefTitle :result="5">{{ recipientTitle }}</DefTitle>
                    </template>
                    <CheckoutRecipient />
                </CheckoutBlock>
            </div>
            <aside class="checkout-aside">
                <div class="checkout-sticky">
                    <CheckoutBasket />
                    <Coupon v-if="!coupons" />
                    <CouponApplied
                        v-for="(coupon, key) in coupons"
                        :result="key"
                        :key="key"
                    />
                    <CheckoutTotal />
                </div>
            </aside>
        </form>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import DefTitle from "../def/DefTitle/DefTitle";
import CheckoutBlock from "./CheckoutBlock";
import CheckoutContact from "./CheckoutContact/CheckoutContact";
import CheckoutLogIn from "./CheckoutLogIn";
import CheckoutTotal from './CheckoutTotal';
import Coupon from "./Coupon/Coupon";
import CouponApplied from "./Coupon/CouponApplied";
import CheckoutDelivery from "./CheckoutDelivery/CheckoutDelivery";
import CheckoutPaySystem from "./CheckoutPaySystem/CheckoutPaySystem";
import Certificate from "./Certificate/Certificate";
import DefProgramMe from "../def/DefProgramMe/DefProgramMe";
import CheckoutRecipient from "./CheckoutRecipient/CheckoutRecipient";
import CheckoutBasket from "./CheckoutBasket/CheckoutBasket";

export default {
    name: 'Checkout',
    selector: '.checkout',
    props: ['result'],
    components: {
        DefTitle,
        CheckoutBlock,
        CheckoutContact,
        CheckoutLogIn,
        CheckoutTotal,
        Coupon,
        CouponApplied,
        CheckoutDelivery,
        CheckoutPaySystem,
        Certificate,
        DefProgramMe,
        CheckoutRecipient,
        CheckoutBasket,
    },
    data() {
        return {
            activeStep: true,
        }
    },
    computed: {
        ...mapState({
            messages: ({ checkout }) => checkout.data.vue.messages,
            contactTitle: ({ checkout }) => checkout.data.vue?.userFields?.title,
            deliveryTitle: ({ checkout }) => checkout.data.vue?.delivery?.title,
            recipientTitle: ({ checkout }) => checkout.data.vue?.recipient?.title,
            paySystemTitle: ({ checkout }) => checkout.data.vue?.paySystem?.title,
            coupons: ({ basket }) => basket.data?.price?.coupons,
        }),
    },
    methods: {
        ...mapActions({
            saveOrder: 'checkout/saveOrder',
            initIPostDelivery: 'checkout/initIPostDelivery',
        })
    },
    mounted() {
        this.initIPostDelivery();
    }
}
</script>

<style lang="scss" scoped>
.checkout{
    counter-reset: section;
    margin-bottom: 56px;
    @include point-md{
        margin-bottom: 80px;
    }
}
.checkout-grid{
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 4px;
    @include point-lg{
        grid-template-columns: 67% 33%;
        grid-column-gap: 4px;
    }
}
.checkout-edit{
    display: block;
    margin: 16px 0 24px;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: #363636;
    svg{
        width: 8px;
        height: 8px;
        fill: currentColor;
        margin-right: 4px;
    }
}
.checkout-steps{
    display: grid;
    grid-row-gap: 4px;
}
.checkout-aside{

}
.checkout-sticky{
    display: grid;
    grid-row-gap: 4px;
    @include point-lg{
        position: sticky;
        top: 50px;
    }
}
</style>